import Browser from 'cars-ng-browser';
import vdpStatTrackingService from './vdpStatTrackingService';

export default angular.module("common.vdp", [ Browser ])
    .factory("vdpStatTrackingService", vdpStatTrackingService)
    .name;